import { api } from "@/lib/api";

export const rmApi = {
  meta: () => api.get("/raw-materials/meta").then((r) => r.data),
  stats: () => api.get("/raw-materials/stats").then((r) => r.data),
  productionJobs: () => api.get("/raw-materials/production-jobs").then((r) => r.data),

  listMaterials: (params) => api.get("/raw-materials/materials", { params }).then((r) => r.data),
  getMaterial: (id) => api.get(`/raw-materials/materials/${id}`).then((r) => r.data),
  createMaterial: (body) => api.post("/raw-materials/materials", body).then((r) => r.data),
  updateMaterial: (id, body) => api.put(`/raw-materials/materials/${id}`, body).then((r) => r.data),

  listGrn: (params) => api.get("/raw-materials/grn", { params }).then((r) => r.data),
  createGrn: (body) => api.post("/raw-materials/grn", body).then((r) => r.data),

  listIssues: (params) => api.get("/raw-materials/issues", { params }).then((r) => r.data),
  createIssue: (body) => api.post("/raw-materials/issues", body).then((r) => r.data),

  listAdjustments: (params) => api.get("/raw-materials/adjustments", { params }).then((r) => r.data),
  createAdjustment: (body) => api.post("/raw-materials/adjustments", body).then((r) => r.data),
  decideAdjustment: (id, approve) => api.patch(`/raw-materials/adjustments/${id}/decide`, { approve }).then((r) => r.data),

  currentStock: () => api.get("/raw-materials/current-stock").then((r) => r.data),
  consumption: (params) => api.get("/raw-materials/consumption", { params }).then((r) => r.data),
  valuation: () => api.get("/raw-materials/valuation").then((r) => r.data),
  ledger: (params) => api.get("/raw-materials/ledger", { params }).then((r) => r.data),
};

export const CATEGORY_LABEL = {
  base_fabric: "Base Fabric Roll",
  sublimation_paper: "Sublimation Paper Roll",
  ink: "Ink",
  chemical: "Chemical",
  packing: "Packing Material",
  consumable: "Other Consumable",
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
